import classes from '../../tables/Table.module.css'
import { useState, useEffect } from 'react';

function Right(props) {
      
    const [Styles, setStyles] = useState("default");
    
    let button_style = `${classes.right}`; //"nav_button default";

    useEffect(() => {
        if ( props.active )
        {
            setStyles("default");
        }
    }, [props.active]);

    function handleMouseEnter()
    {
        setStyles("hover");
    }
    
    function handleMouseLeave()
    {
        setStyles("default");
    }
    

    if ( Styles==="default" )
    {
        button_style = `${classes.right}`; //"nav_button default";
    }
    
    if ( Styles==="hover" )
    {
        button_style = `${classes.right} ${classes.hover}`; //"nav_button hover";
    }
    if ( !props.active )
    {
        button_style = `${classes.right} ${classes.inactive}`; //"nav_button inactive";
    }

    return(
        <div style={{postion: 'relative', width:'10px', height:'10px'}}>
            {props.active ? (
                <button id={props.id} className={button_style} onClick={props.handleClick} onMouseLeave={handleMouseLeave} onMouseEnter={handleMouseEnter}></button>
            ) : (
                <button className={button_style} ></button>
            )}
        </div>
    );

}


export default Right;